import VueRouter from 'vue-router';

import { runEntrypoint, runExternalEndpointComplementaryInitialization } from './main-common';
import FlowRun from './views/FlowRun/FlowRun.vue';
import { TEST_MODE_QUERY_PARAM } from './views/FlowRun/flow-run.const';
import { propsValidator } from '@/utils/helpers';

const router = new VueRouter({
	mode: 'history',
	routes: [
		{
			// extraId is here to allow URLs built by extension in 'native platforms'

			path: '/run/:hashId/:extraId?',
			name: 'FlowRun',
			component: FlowRun,
			props(route) {
				return propsValidator(route, FlowRun, { isTestMode: route.query[TEST_MODE_QUERY_PARAM] === '1' });
			},
		},
		{
			path: '/resume/:flowVersionId/:resumeId',
			name: 'FlowRunResume',
			component: FlowRun,
			props(route) {
				return propsValidator(route, FlowRun);
			},
		},
		{
			path: '*',
			name: 'FlowRunCatchAll',
			component: FlowRun,
		},
	],
});

runEntrypoint({ router });
runExternalEndpointComplementaryInitialization();
